// Axios and configuration
import Axios from "axios"
import AxiosConfig from "src/utilities/AxiosConfig"

// Interfaces
import I_BaseAPIResponse from "src/common_interfaces/I_BaseAPIResponse"
import { I_ApprovalAudit } from "../interfaces"

// Utilities
import snackBar from "src/utilities/snackBar/SnackBar"

/**
 * Fetches the approval audit trail for a specific record.
 *
 * @param recordTypeId - The type ID of the record (e.g., incident, form, etc.)
 * @param recordId - The specific record's ID
 * @returns A list of approval audit entries or an empty array on failure
 */
const GetApprovalAuditTrail = async (
  recordTypeId: number,
  recordId: number
): Promise<I_ApprovalAudit[]> => {
  try {
    const response = await Axios.get<I_BaseAPIResponse<I_ApprovalAudit[]>>(
      `${process.env.REACT_APP_API_URL}/api/approval/audit?recordTypeId=${recordTypeId}&recordId=${recordId}`,
      AxiosConfig.configValue("min")
    )

    if (response.data.HasError) {
      snackBar({
        type: "error",
        text: response.data.ErrorMessage,
        timeout: 4000
      })
      return []
    }

    return response.data.Data
  } catch (error) {
    console.error("GetApprovalAuditTrail failed:", error)
    snackBar({
      type: "error",
      text: "Failed to fetch audit trail",
      timeout: 4000
    })
    return []
  }
}

export default GetApprovalAuditTrail
